import { useMemo } from 'react'

import { hasPermission } from '@hap/auth/src/permission'
import { Roles } from '@hap/constants'

import useCurrentUser from '../../hooks/useCurrentUser'

export function usePermission(input: {
  resource: Roles.ResourceType
  actions: Roles.Permission[]
}): boolean {
  const currentUser = useCurrentUser()
  return useMemo(() => {
    if (!currentUser) return false
    return hasPermission({
      permissions: currentUser.permissions,
      resource: input.resource,
      actions: input.actions,
    })
  }, [currentUser, input.resource, input.actions])
}

export function useInteractionPermission(input: {
  handledByIds?: string[] | null
}): boolean {
  const currentUser = useCurrentUser()
  const viewAllPermission = usePermission({
    resource: 'interactions_view_all',
    actions: ['manage', 'view_all'],
  })
  const viewHandledPermission = usePermission({
    resource: 'interactions_view_all',
    actions: ['view_limited'],
  })

  if (viewAllPermission) return true

  if (viewHandledPermission && currentUser && input.handledByIds)
    return input.handledByIds.includes(currentUser.id)

  return false
}
